import { IToothDetails } from './appointment.type'
import { IPatient } from './chat.type'
import { INote } from './note.type'
import { IProcedureLog } from './procedure.types'
import { ProcedureSettingsType } from './procedureSettings.type'

export const TX_PLAN_STATUS = {
  PROPOSED: 'Proposed',
  ACCEPTED: 'Accepted',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
} as const

export type TxPlanStatus = (typeof TX_PLAN_STATUS)[keyof typeof TX_PLAN_STATUS]

export interface ITreatmentPlan {
  tp_id: string
  patient_id: string
  clinic_id: string
  insurance_plan_id: string | null
  tp_heading: string
  tp_note?: string
  tp_type?: string
  isDraft: boolean
  discount_id: string | null
  discount?: number | null
  date_time_created_at?: string
  date_time_updated_at?: string
  procedures?: IProcedureLog[]
  phases?: IPhases[]
  patient?: IPatient
  notes?: INote[]
  created_by?: string
  updated_by?: string
}

export interface ITreatmentPlanAttach {
  tp_attach_id: string
  tp_id: string
  proc_log_id: string
  priority: number
  date_time_created_at: string
  date_time_updated_at: string
}

export interface IPhases {
  phase_id?: string | null
  phase_name: string
  scheduled_date: string | null
  status: TxPlanStatus
  items: IPhaseItems[]
  is_hidden?: boolean
}

export interface IProcedureDentalCondition {
  id: string
  procedure_id: string
  dental_condition_id: string
  default_material: string | null
  default_type: string | null
  default_surface: string | null
  requires_surface_selection?: boolean
  surface_count?: number | null
  surface_count_is_min?: boolean
  surface_archetype?: 'anterior' | 'posterior' | null
  dental_condition?: {
    id: string
    slug: string
    name: string
    category: string | null
    allowed_materials?: string[]
    allowed_types?: string[]
  }
}

export interface IToothSurface {
  ts_id: string
  item_id: string
  area_type: number | null
  area: string | null
  tooth: string | null
  surf: string | null
}

export interface IPhaseItems {
  item_id: string
  phase_id?: string | null
  procedure_id: string | null
  provider_id?: string
  surface?: string | null
  material?: string | null
  type?: string | null
  charges: number
  insurance: number
  adjustments: number
  outstanding: number
  allowed_amount?: number | null
  write_off?: number | null
  procedure_settings?: ProcedureSettingsType
  proceduredentalcondition?: IProcedureDentalCondition[]
  tooth_surfaces?: IToothSurface[]
  is_hidden?: boolean
}

export interface Procedure {
  procedure_id: string
  procedure_code: string
  description: string
  surface: string
}

export type TxPlanProcedureModalContext = {
  phaseIndex: number
  presetToothDetails?: IToothDetails[]
  initialQuery?: string
}
